module.exports = __webpack_public_path__ + "static/media/img-consumer-wallet-new.74b71f51.pdf";